module.exports = __webpack_public_path__ + "img/FIAT.9ac8409f.svg";